module.exports = new __parcel__URL__("image-product-4.0c4028d7.jpg").toString();